import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-indent",
  "use": "icon-indent-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-indent\"><g id=\"icon-indent_fill\"><polygon points=\"3.38 0.5 0.5 0.5 0.5 19.05 17.75 19.05 17.75 23.5 23.5 17.57 17.75 11.63 17.75 16.08 3.38 16.08 3.38 0.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol